<template>
    <div>
        <b-container>
            <b-row align-h="center">
                <b-col cols="8">
                    <b-card-group deck>
                        <b-card header="Configure the DataForma Integration" header-tag="header">
                            <b-container>
                                <b-row align-h="center">
                                    <b-col cols="8">
                                        <b-form @submit.prevent="updateDataForma">
                                            <b-form-group
                                                id="input-group-1"
                                                label="Enter your DataForma Service Code"
                                                label-for="fcsMasterId">
                                                <b-form-input
                                                    id="fcsMasterId"
                                                    v-model="serviceCode"
                                                    type="text"
                                                    placeholder="Service Code">
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group
                                                id="input-group-2"
                                                label="Enter your DataForma API Key"
                                                label-for="fcsUserId">
                                                <b-form-input
                                                    id="fcsUserId"
                                                    v-model="dfAuthId"
                                                    type="text"
                                                    placeholder="API Key">
                                                </b-form-input>
                                            </b-form-group>
                                            <b-button :disabled="isLoading" type="submit" variant="primary">
                                                Save
                                                <i v-if="isLoading"
                                                   class="fa fa-spin fa-spinner text-grey-darkest"
                                                   aria-hidden="true">
                                                </i>
                                            </b-button>
                                            <b-button v-if="isDisconnectButton" @click="disconnectDataForma()" :disabled="isLoadingDisconnect" type="button" variant="danger">
                                                Disconnect
                                                <i v-if="isLoadingDisconnect"
                                                   class="fa fa-spin fa-spinner text-grey-darkest"
                                                   aria-hidden="true">
                                                </i>
                                            </b-button>
                                        </b-form>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
export default {
    name: 'dataforma-integration',
    props: ['team'],
    data() {
        return {
            serviceCode: this.team.dataforma_service_code ?? '',
            dfAuthId: this.team.dataforma_auth_id ?? '',
            isLoading: false,
            isDisconnectButton: !!(this.team.dataforma_service_code && this.team.dataforma_auth_id),
            isLoadingDisconnect: false,
        }
    },
    methods: {
        updateDataForma() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            this.isLoading = true;
            axios.post(route('api.settings.dataforma'),
                {
                    serviceCode: this.serviceCode,
                    dfAuthId: this.dfAuthId
                }).then((dataFormaResp) => {

                if (dataFormaResp.data.status) {
                    this.isDisconnectButton= !!(this.serviceCode && this.dfAuthId);
                    Toast.fire({
                        type: 'success',
                        title: "Your DataForma Integration has been updated."
                    });
                } else {
                    Toast.fire({
                        type: 'error',
                        title: dataFormaResp.data.message
                    });
                }
            }).catch(() => {
                Toast.fire({
                    type: 'error',
                    title: "Action failed. Try re-generation and updating the API key"
                });
            }).finally(() => {
                this.isLoading = false;
            })
        },
        disconnectDataForma() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            this.isLoadingDisconnect = true;
            axios.post(route('api.settings.dataforma-disconnect')).then((dataFormaResp) => {

                if (dataFormaResp.data.status) {
                    this.isLoadingDisconnect = false;
                    Toast.fire({
                        type: 'success',
                        title: "Your DataForma Integration has been disconnected."
                    });
                    this.isDisconnectButton = false;
                } else {
                    this.isLoadingDisconnect = false;
                    Toast.fire({
                        type: 'error',
                        title: dataFormaResp.data.message
                    });
                }
            }).catch(() => {
                Toast.fire({
                    type: 'error',
                    title: "Error on update your DataForma Integration."
                });
            }).finally(() => {
                this.isLoadingDisconnect = false;
            })
        },
    }
}
</script>

<style scoped>

</style>
